export const WALLET_BETA_DISCLAIMER_SESSION_KEY =
  "genrl.wallet.beta-disclaimer.accepted.v1";

function acceptedUserID(): string {
  if (typeof window === "undefined") return "";
  try {
    return String(
      window.sessionStorage.getItem(WALLET_BETA_DISCLAIMER_SESSION_KEY) || "",
    ).trim();
  } catch {
    return "";
  }
}

export function shouldShowWalletBetaDisclaimer(userID?: string): boolean {
  const normalizedUserID = String(userID || "").trim();
  if (!normalizedUserID || typeof window === "undefined") return false;
  return acceptedUserID() !== normalizedUserID;
}

export function acceptWalletBetaDisclaimer(userID?: string) {
  const normalizedUserID = String(userID || "").trim();
  if (!normalizedUserID || typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(
      WALLET_BETA_DISCLAIMER_SESSION_KEY,
      normalizedUserID,
    );
  } catch {
    // The acknowledgement still applies for this render if browser storage is unavailable.
  }
}

export function resetWalletBetaDisclaimerAcceptance() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(WALLET_BETA_DISCLAIMER_SESSION_KEY);
  } catch {
    // Browser storage is best-effort; the dialog defaults to showing when it cannot be read.
  }
}
